import React, { memo, useRef, useState } from 'react';
import PercentageProgressRing from '../PercentageProgressRing';
import UpdateCaseTypeModal from './UpdateCaseTypeModal';
import { useDispatch, useSelector } from 'react-redux';
import { easySnackbar } from '../../store/Noti/noti.actions';
import { safePost } from '../../axios-default';
import useTreatmentOptionForTpApproval from '../../hooks/useTreatmentOptionForTpApproval';
import { ClinicalApprovementOption } from '../../pages/SmileDesign/clinicalApprovementOptionConstants';

const UpgradeAlignerCaseTypeModal = ({ openExtenal, handleOpenExternal, planId, caseId }) => {
    const progressBarRef = useRef(null);
    const treatmentPlanApproval = useSelector((state) => state.treatmentPlanApproval);
    const { shouldApproveUpsellPart, upsellType } = treatmentPlanApproval;
    const clinicalSimulationCase = useSelector((state) => state.clinicalSimulation.patientInfoData);
    const planIdinMultiplePlan = useSelector((state) => state.smileDesign.planId);
    const currentCaseId = caseId === undefined ? clinicalSimulationCase?.case_id : caseId;
    const currentPlanId = planId === undefined ? planIdinMultiplePlan : planId;
    const { productMatrixArray, defaultCaseType, isFetchingProductmatrixForDr, optionSelected, setOptionSelected } =
        useTreatmentOptionForTpApproval({
            caseId: currentCaseId,
            planId: currentPlanId,
            openExternal: openExtenal,
        });

    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);

    const onSubmit = async (approveMode) => {
        // Keep the upsell approval option aligned with the target branch.
        const { case_id } = clinicalSimulationCase;

        let currentCaseId = caseId === undefined ? case_id : caseId;
        let upsellApprovementOption = undefined;
        try {
            const selectedOption = approveMode === 'approve_current' ? defaultCaseType : optionSelected;
            const body = {
                upgradeOption: {
                    allowUpgrade: approveMode === 'upgrade',
                    case_type: selectedOption['case_type'],
                    case_type_id: selectedOption['case_type_id'],
                },
                defaultCaseTypeId: defaultCaseType['case_type_id'],
            };

            if (shouldApproveUpsellPart && upsellType) {
                upsellApprovementOption = ClinicalApprovementOption[1];
            }

            setIsLoading(true);
            const result = await safePost(
                `case/${currentCaseId}/treatment_plan/${currentPlanId}/approve`,
                {
                    upgradeCaseType: body,
                    upsellApprovementOption,
                },
                {
                    onUploadProgress: progressBarRef.current?.onProgressChange,
                }
            );

            if (result.success) {
                setIsLoading(false);
                dispatch(easySnackbar(`Updated`, 'success'));
                window.location.reload();
            } else {
                let basedMessage = 'An unexpected error occurred';
                if (result?.message) {
                    basedMessage = result?.message;
                }
                if (result?.response?.data?.message) {
                    basedMessage = result?.response?.data?.message;
                }
                throw new Error(basedMessage);
            }
        } catch (e) {
            setIsLoading(false);
            let errorMessage = 'An unexpected error occurred';
            if (e?.message) {
                errorMessage = e.message;
            }
            dispatch(easySnackbar(errorMessage, 'error'));
        }
    };

    return (
        <>
            <PercentageProgressRing ref={progressBarRef} open={isLoading} label={undefined} />

            <UpdateCaseTypeModal
                open={openExtenal}
                handleClose={handleOpenExternal}
                handleDataSave={onSubmit}
                optionSelected={optionSelected}
                setOptionSelected={setOptionSelected}
                productMatrixArray={productMatrixArray}
                isFetchingProductmatrixForDr={isFetchingProductmatrixForDr}
                defaultCaseType={defaultCaseType}
                closeButtonLabel="Cancel"
            />
        </>
    );
};

export default memo(UpgradeAlignerCaseTypeModal);
